module.exports = __webpack_public_path__ + "static/media/fax.49b2f192.svg";